import React from 'react'
import { ReactComponent as PgaCoachLogoSvg } from 'images/pga-coach-logo.svg'
import { ReactComponent as PgaCoachPlusLogoSvg } from 'images/pga-coach-plus-logo.svg'

export const PgaCoachLogo = ({ className }) => (
  <PgaCoachLogoSvg className={className} aria-label="PGA Coach" role="img" />
)

export const PgaCoachPlusLogo = ({ className }) => (
  <PgaCoachPlusLogoSvg
    className={className}
    aria-label="PGA Coach+"
    role="img"
  />
)
